import axios from 'axios';

let prefix = "/category-tag"

const CategoryTagApi = {

	getCategoryTagListAll(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getCategoryTagList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getCategoryTagById(id, payload){
		return axios.get( prefix + "/get/" + id, {params: payload})
	},
	createCategoryTag(payload){
		return axios.post( prefix + "/create", payload)
	},
	updateCategoryTag(payload){
		return axios.post( prefix + "/update", payload)
	},
	archiveCategoryTag(payload){
		return axios.delete( prefix + "/delete", {params: payload})
	},

}

export default CategoryTagApi;